import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
//Language
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, ToggleSwitch, Select, RadioButton } from "@gpstrackit/react-controls";
import { Grid } from "@mui/material";
import CustomCard from 'Components/Card';
import { Alert, AlertTitle } from '@mui/material';
//Icons
import { copyToClipboard } from 'Core/data/Helpers';

//Notification
import { NotificationManager } from "Components/Notifications";
import _ from 'lodash';

//Actions
import {
    createDiagnosticDeviceGetDeviceRequest,
    createDiagnosticDeviceCloseModal,
    createDiagnosticDeviceSearchDeviceModelRequest,
    createDiagnosticDeviceSetDevices,
    createDiagnosticDeviceRequest,
    clearRedux,
} from 'Redux/actions';


const CreateDiagnosticDevice = (props) => {
    const formRef = useRef();
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate()

    const { loading, openModal, result, device, devices } = useSelector(state => state.createDiagnosticDeviceRedux);
    const [serial, setSerial] = useState("");
    
    const closeModal = () => {
        dispatch(createDiagnosticDeviceCloseModal());
        setSerial("");
        dispatch(clearRedux("CREATE_DIAGNOSTIC_DEVICE"));
    }

    const searchDevice = () => {
        let deviceSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];

            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();
                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (devices && devices.length) {
                    let already = devices.find(x => x.imei === escCriteria || x.esn === escCriteria);
                    if (!already)
                        criterias.push(escCriteria);
                } else {
                    criterias.push(escCriteria);
                }
            });

            if (criterias.length) {
                dispatch(createDiagnosticDeviceGetDeviceRequest(criterias));
            } else {
                NotificationManager.warning(
                    messages['create_diagnostic_device_the_devices_has_already_been_added'],
                    messages['create_diagnostic_device_title'],
                    3000
                );
            }

        } else {
            let isValid = true;
            for (let index in devices) {
                let device = devices[index];
                if (device.esn.toString() === serial) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                dispatch(createDiagnosticDeviceGetDeviceRequest([serial]));
            } else {
                NotificationManager.warning(
                    messages['create_diagnostic_device_the_device_has_already_been_added'],
                    messages['create_diagnostic_device_title'],
                    3000
                );
            }
        }
    }

    const applyChanges = () => {
        let payload = {
            unitIds: []
        }
        let unitIds = [];

        if (devices && devices.length) {
            devices.map((device) => {
                unitIds.push(device?.id)
            })
            payload.unitIds = unitIds;
        }
        dispatch(createDiagnosticDeviceRequest(payload));

    }

    useEffect(() => {

        if (device) {
            if (!device?.total) {
                NotificationManager.warning(
                    messages['create_diagnostic_device_the_device_has_not_been_found'],
                    messages['create_diagnostic_device_title'],
                    3000
                );
            } else {
                const { items } = device;
                if (devices.length === 0 && items.length > 0) {
                    dispatch(createDiagnosticDeviceSetDevices(items));
                } else if (devices.length && items.length > 0) {
                    dispatch(createDiagnosticDeviceSetDevices([device, ...items]));
                }

                setSerial("")
            }
            dispatch(clearRedux("CREATE_DIAGNOSTIC_DEVICE", { device: null }))
        }
        if (result) { 
            dispatch(clearRedux("CREATE_DIAGNOSTIC_DEVICE", { result: null }));
            if (!result?.error) {
                let transactionId = result.DiagnosticResult.transactionId;
                let message = messages["create_diagnostic_device_transaction_request_message"]
                NotificationManager.success(message, messages['create_diagnostic_device_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

                closeModal();

            } else {
                let error = true;
                let message = messages["devices_import_save_error"]
                if (result?.error?.error) {
                    if (messages[result.error.error])
                        message = messages[result.data.error.error]
                    else
                        message = result.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }
            }
        }
    }, [device, result]);

    useEffect(() => {
        if (openModal && devices.length > 0) {
            let unitIds = devices.map((item) => (item?.id))
            dispatch(createDiagnosticDeviceSearchDeviceModelRequest(unitIds));
        }
    }, [openModal])


    return (
        <Modal
            open={openModal}
            title={messages['create_diagnostic_device_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                {
                    <div style={{ padding: '0 10px', marginBottom: 30 }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Input
                                        label={messages['create_diagnostic_device_imei_or_serial']}
                                        placeholder={messages['create_diagnostic_device_imei_or_serial']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        value={serial}
                                        onChange={(value) => setSerial(value)}
                                        maxLength={4000}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {devices?.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let filtered = devices.filter((device) => device.id !== item.id);
                                        dispatch(createDiagnosticDeviceSetDevices(filtered));
                                    }}

                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['create_diagnostic_device_imei']}</label><span>{item?.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['create_diagnostic_device_serial']}</label><span>{item?.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['create_diagnostic_device_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                <Button
                    className={"btn-cancel"}
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={devices.length === 0}
                    className="btn-dark-blue"
                    onClick={() => {
                        applyChanges();
                    }}
                >
                    {messages['create_diagnostic_device_create']}
                </Button>

            </ModalFooter>
        </Modal>
    )
}

export default CreateDiagnosticDevice;